import React, { useState, useEffect } from "react";
import { UserAuth } from "../Context";
import { toast } from "react-toastify";
import { toastOptions } from "../lib/toastOptions";
import { db } from "../FirebaseConfig";
import {
  getDocs,
  collection,
  setDoc,
  doc,
  serverTimestamp,
  getDoc, // Import getDoc to retrieve individual friend data
} from "firebase/firestore";
import uuid4 from "uuid4";
import useModalStore from "../StatesStore/ModalStore";
import { saveMessageToDB } from "../Chat/lib.js/saveMsgToDb";
import useSocketStore from "../StatesStore/Socket";
import { encryptChat } from "../ShoppingList/Encryption";
import useChatClient from "../StatesStore/ChatClient";
import { generateChatId } from "../Chat/lib.js/generateChatId";
import { getBaseURL } from "../lib/getBaseURL";
import { Modal } from "react-bootstrap";
import ShareMenu from "../Referral/ShareMenu";

function AddToChat({ product, socket, componentName }) {
  const { user } = UserAuth();
  const [friends, setFriends] = useState([]);
  const [content, setContent] = useState("");
  const [selectedFriends, setSelectedFriends] = useState([]);
  const { openModal } = useModalStore();
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);

  const [showPrimaryModal, setShowPrimaryModal] = useState(false);
  const [showSecondaryModal, setShowSecondaryModal] = useState(false);
  const [selectedFriend, setSelectedFriend] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleCloseSecondaryModal = () => {
    // setSelectedFriends([]);
    setContent("");
    setShowSecondaryModal(false);
  };

  const handleClosePrimaryModal = () => {
    setSelectedFriends([]);
    setContent("");
    setShowPrimaryModal(false);
  };
  // const socket = useSocketStore((state) => state.socket);
  // Fetch user's active friends and their names
  const client = useChatClient((state) => state.client);
  const fetchFriends = async () => {
    if (!user) return;

    const connectionsRef = collection(db, "users", user.uid, "connections");
    const activeFriendsSnapshot = await getDocs(connectionsRef);
    const activeFriends = activeFriendsSnapshot.docs
      .filter((doc) => doc.data().type === "active")
      .map((doc) => doc.id); // Get only the friend's document ID (friendId)

    // Fetch the userName for each active friend
    const friendsWithNames = await Promise.all(
      activeFriends.map(async (friendId) => {
        const friendDocRef = doc(db, "users", friendId); // Reference to the friend's doc
        const friendDoc = await getDoc(friendDocRef);
        if (friendDoc.exists()) {
          const friendData = friendDoc.data();
          return {
            id: friendId,
            name: friendData.userName, // Get the userName from the document
          };
        } else {
          console.error("No such friend document!");
          return null;
        }
      })
    );

    // Filter out null values (if any friend documents were not found)
    setFriends(friendsWithNames.filter((friend) => friend !== null));
  };

  useEffect(() => {
    if (user) {
      fetchFriends();
    }
  }, [user]);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Handle friend selection
  const handleFriendSelect = (friendId) => {
    setSelectedFriends((prevSelected) => {
      if (prevSelected.includes(friendId)) {
        return prevSelected.filter((id) => id !== friendId);
      } else {
        return [...prevSelected, friendId];
        // return [friendId];
      }
    });
  };

  // Save chat message when friends are selected
  const handleSendMessage = async () => {
    if (!selectedFriends.length) {
      toast.warning("Please select at least one friend.", toastOptions);
      return;
    }
    const baseURL = getBaseURL();
    try {
      setLoading(true);
      await Promise.all(
        selectedFriends.map(async (friendId) => {
          const msgData = {
            senderId: user.uid,
            receiverId: friendId,
            content: encryptChat(content),
            productId: product.id,
            type: "product",
          };
          const msgToBeSent = {
            senderId: user.uid,
            receiverId: friendId,
            content: encryptChat(content),
            productId: product.id,
            type: "product",
            details: product,
          };
          // if (socket) {
          //   socket.emit("chat msg", msgToBeSent);
          //   // setMsgs((prevMsgs) => [...prevMsgs, msgToBeSent]);
          // }
          const channelId = generateChatId(user.uid, friendId);

          // Initialize the channel
          const channel = client.channel("messaging", channelId, {
            members: [user.uid, friendId],
          });
          await channel.watch();
          const attachments = [
            {
              image: product?.imageUrl,
              product,
              type: "product",
            },
          ];
          await channel.sendMessage({
            productId: product?.id,
            product: product,
            attachments,
          });
          if (content.trim()) {
            await channel.sendMessage({
              text: `${content}`,
              productId: product?.id,
              product: product,
            });
          }
          await saveMessageToDB(msgData);
        })
      );

      toast.success("Message sent!", toastOptions);
      setSelectedFriends([]); // Reset after sending
      setShowPrimaryModal(false);
      setShowSecondaryModal(false);
      setContent("");
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error sending message:", error);
      toast.error("Failed to send message. Try again.", toastOptions);
    }
  };

  const handleClick = () => {
    if (!user) {
      openModal("SignInModal", "", "");
    } else if (!user?.emailVerified) {
      openModal("VerifyEmailModal", "", {
        userName: user?.displayName,
        email: user?.email,
      });
    } else setShowPrimaryModal(true);
  };

  return (
    <div className="d-flex justify-content-between addToChat">
      <li className={`btn nav-item p-0`}>
        {user ? (
          <>
            <button
              className={`nav-link btn d-flex gap-1 align-items-center bg-default list-unstyled ${componentName !==
                "Discover" && "text-white"}`}
              id="chatActionDropdown"
              // data-bs-toggle={user?.emailVerified && "dropdown"}
              // aria-expanded="false"
              onClick={handleClick}
            >
              {componentName === "Discover" ? (
                <div
                  className="h6 mb-0 text-primary fw-light"
                  style={{ fontSize: isSmallScreen ? "0.65rem" : "0.8rem" }}
                >
                  <u>Ask a Friend</u>
                </div>
              ) : (
                <>
                  <i className="bi bi-person-plus fs-6"></i>
                  {"Ask a Friend"}
                </>
              )}
              {/* {"Share with friends"} */}
            </button>
            <style jsx>
              {`
                .primaryModal .modal-dialog {
                  max-width: 32rem;
                }
                .secondaryModal .modal-dialog {
                  max-width: 35rem;
                }
                .secondaryModal .modal-content {
                  box-shadow: 0 0 14px rgba(0, 0, 0, 0.5);
                }
                .modal-backdrop {
                  z-index: 1060 !important;
                }
              `}
            </style>
            <Modal
              show={showPrimaryModal}
              onHide={handleClosePrimaryModal}
              centered
              className="primaryModal"
            >
              <Modal.Body style={{ padding: isSmallScreen ? "1rem" : "2rem" }}>
                <div className="d-flex flex-column mb-3">
                  <div className="d-flex w-100 justify-content-between">
                    <div className="h4">
                      {friends.length > 0
                        ? "Ask A Friend"
                        : "No Friends Added Yet"}
                    </div>
                    <button
                      type="button"
                      style={{
                        boxSizing: "border-box",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "27px",
                        height: "27px",
                        background: "#FFFFFF",
                        border: "1px solid #FF3B30",
                        boxShadow: "1px 1px 5px rgba(30, 30, 30, 0.14)",
                        borderRadius: "25px",
                        flex: "none",
                        order: "1",
                        flexGrow: "0",
                      }}
                      onClick={handleClosePrimaryModal}
                    >
                      <svg
                        style={{ width: "11px" }}
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13 1L1 13M1 1L13 13"
                          stroke="#FF3B30"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </button>
                  </div>
                  <p className="m-0">
                    {friends.length > 0
                      ? "Ask your friends for the quick suggestion on the products."
                      : "Add friends to start sharing and inviting them to your shopping lists. Shopping is more fun together!"}
                  </p>
                </div>
                {friends?.length > 0 ? (
                  <>
                    <div
                      className="pb-2 d-flex flex-column gap-3"
                      style={{ maxHeight: "18.5rem", overflow: "auto" }}
                    >
                      {friends.map((friend) => (
                        <div
                          key={friend.id}
                          className="d-flex align-items-center justify-content-between bg-white shadow-sm px-3 py-2 rounded-3"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            handleFriendSelect(friend.id);
                            setSelectedFriend(friend.name);
                          }}
                        >
                          <div>{friend.name}</div>
                          <input
                            type="checkbox"
                            style={{ width: "15px", height: "15px" }}
                            checked={selectedFriends.includes(friend.id)}
                          />
                        </div>
                      ))}
                    </div>
                    <button
                      disabled={selectedFriends.length === 0}
                      onClick={() => setShowSecondaryModal(true)}
                      className="w-100 btn btn-primary mt-3 rounded-3"
                    >
                      Ask
                    </button>
                  </>
                ) : (
                  <>
                    <div
                      // onClick={() => setShowSecondaryModal(true)}
                      className="w-100 btn btn-primary mt-3 rounded-3 d-flex align-items-center justify-content-center"
                    >
                      <ShareMenu componentName={"AddToChat"} />
                    </div>
                  </>
                )}
              </Modal.Body>
            </Modal>
            <Modal
              show={showSecondaryModal}
              onHide={handleCloseSecondaryModal}
              centered
              className="secondaryModal"
            >
              <Modal.Body style={{ padding: isSmallScreen ? "1rem" : "2rem" }}>
                <div className="d-flex flex-column mb-3">
                  <div className="d-flex w-100 justify-content-between">
                    <div className="h4">
                      Send message to{" "}
                      {selectedFriends.length === 1
                        ? friends.find((f) => f.id === selectedFriends[0])?.name
                        : `${selectedFriends.length} friends`}
                    </div>

                    <button
                      type="button"
                      style={{
                        boxSizing: "border-box",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "27px",
                        height: "27px",
                        background: "#FFFFFF",
                        border: "1px solid #FF3B30",
                        boxShadow: "1px 1px 5px rgba(30, 30, 30, 0.14)",
                        borderRadius: "25px",
                        flex: "none",
                        order: "1",
                        flexGrow: "0",
                      }}
                      onClick={handleCloseSecondaryModal}
                    >
                      <svg
                        style={{ width: "11px" }}
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13 1L1 13M1 1L13 13"
                          stroke="#FF3B30"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </button>
                  </div>
                  <p className="m-0">
                    Send a message to your friend to ask about the product you
                    like.
                  </p>
                </div>
                <div className="input-group d-flex flex-column gap-3 mt-1">
                  <textarea
                    className="form-control form-control-sm w-100 shadow-lg rounded-3"
                    placeholder="Type your message here"
                    style={{ height: "100px" }}
                    value={content}
                    onChange={(e) => setContent(e.target.value)}
                  />
                  <div className="w-100 btn btn-primary rounded-3">
                    {loading ? (
                      <div
                        className="spinner-border spinner-border-sm"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    ) : (
                      <div onClick={handleSendMessage}>Send</div>
                    )}
                  </div>
                </div>
              </Modal.Body>
            </Modal>
            {/* <ul
              className="dropdown-menu dropdown-menu-end"
              aria-labelledby="chatActionDropdown"
            >
              <div className="p-2 py-0 text-center">
                <h6>Select Friends</h6>
              </div>
              {friends?.length > 0 ? (
                <>
                  {friends.map((friend) => (
                    <li key={friend.id}>
                      <label className="dropdown-item d-flex gap-2">
                        <input
                          type="checkbox"
                          checked={selectedFriends.includes(friend.id)}
                          onChange={() => handleFriendSelect(friend.id)}
                        />
                        {friend.name}
                      </label>
                    </li>
                  ))}
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <div className="input-group d-flex gap-2 p-2">
                      <input
                        type="text"
                        className="form-control form-control-sm focus-ring focus-ring-secondary py-1 px-2 text-decoration-none border rounded-2"
                        placeholder="Type your message"
                        value={content}
                        onChange={(e) => setContent(e.target.value)}
                      />
                      <button
                        type="button"
                        className="btn btn-sm btn-primary border rounded-2"
                        onClick={handleSendMessage}
                      >
                        Send
                      </button>
                    </div>
                  </li>
                </>
              ) : (
                <>
                  <div className="text-center">You have no friends</div>
                </>
              )}
            </ul> */}
          </>
        ) : (
          <button
            className={`nav-link btn d-flex gap-1 align-items-center bg-default list-unstyled`}
            onClick={handleClick}
          >
            {componentName === "Discover" ? (
              <div
                className="h6 mb-0 text-primary fw-light"
                style={{ fontSize: isSmallScreen ? "0.65rem" : "0.8rem" }}
              >
                <u>Ask a Friend</u>
              </div>
            ) : (
              <>
                <i className="bi bi-person-plus fs-6"></i>
                {"Ask a Friend"}
              </>
            )}
          </button>
        )}
      </li>
    </div>
  );
}

export default AddToChat;
